/** @typedef {'image' | 'pdf'} PatrolDrawingFileType */

export const PATROL_DRAWING_IMAGE_MAX_BYTES = 50 * 1024 * 1024;
export const PATROL_DRAWING_PDF_MAX_BYTES = 150 * 1024 * 1024;

/** @param {File} file */
export function maxPatrolDrawingUploadBytes(file) {
  const name = String(file?.name ?? "").toLowerCase();
  return name.endsWith(".pdf") ? PATROL_DRAWING_PDF_MAX_BYTES : PATROL_DRAWING_IMAGE_MAX_BYTES;
}

/**
 * @param {File | { name?: string, type?: string }} file
 * @returns {PatrolDrawingFileType}
 */
export function getFileTypeFromFile(file) {
  if (!file) return "image";
  const name = (file.name || "").toLowerCase();
  const type = (file.type || "").toLowerCase();
  if (type === "application/pdf" || name.endsWith(".pdf")) return "pdf";
  return "image";
}

/**
 * @param {{ fileType?: string, fileUrl?: string | null, imagePreview?: string | null, fileName?: string }} drawing
 * @returns {PatrolDrawingFileType | null}
 */
export function getDrawingFileType(drawing) {
  if (!drawing) return null;
  if (drawing.fileType === "pdf" || drawing.fileType === "image") {
    return drawing.fileType;
  }
  const name = (drawing.fileName || "").toLowerCase();
  const url = (drawing.fileUrl || drawing.imagePreview || "").toLowerCase();
  if (name.endsWith(".pdf") || url.includes(".pdf")) return "pdf";
  if (drawing.fileUrl || drawing.imagePreview) return "image";
  return null;
}

/**
 * @param {{ fileUrl?: string | null, imagePreview?: string | null, fileType?: string, fileName?: string }} drawing
 */
export function getDrawingMediaUrl(drawing) {
  if (!drawing) return null;
  const type = getDrawingFileType(drawing);
  if (type === "pdf") {
    return drawing.fileUrl || drawing.imagePreview || null;
  }
  return drawing.fileUrl || drawing.imagePreview || null;
}
